import React, {useContext} from "react";
import Img from "../../common/Img";
import MainButton from "../../common/MainButton";
import lbl from "../../../data/Labels.json";
import MainTitle from "../../common/MainTitle";
import {PopUpContext} from "../../../contexts/popUpContext";

const DocumentsInfo = ({student, studentInfo, callback}) => {
    const {togglePopUp} = useContext(PopUpContext);

    return (
        <div className="student-info">
            <div className="main-content-header">
                <div className="left-content">
                    {studentInfo ? <MainButton
                        type="pen"
                        title={lbl.Edit}
                        handleClick={() => togglePopUp({
                            form: "student-documents-info-form",
                            edit: studentInfo,
                            student: student,
                            callback: callback,
                        })}
                    /> : ''}
                </div>
                <div className="right-content">
                    <MainTitle title="اسناد"/>
                </div>
            </div>
            <div className="student-detail">
                <div className="detail_item">
                    <p>کد رسید فیس داخله</p>
                    <p>{studentInfo?.bank_receipt_ref_no}</p>
                </div>
                <div className="detail_item">
                    <p>تذکره</p>
                    <p>{studentInfo?.tazkera_file && (
                        <a href={studentInfo?.tazkera_file} download target="_blank">
                            {lbl.Download}
                        </a>
                    )}</p>
                </div>
                <div className="detail_item">
                    <p>نمرات 3 ساله</p>
                    <p>{studentInfo?.transcript_file && (
                        <a href={studentInfo?.transcript_file} download target="_blank">
                            {lbl.Download}
                        </a>
                    )}</p>
                </div>
                <div className="detail_item">
                    <p>پاسپورت</p>
                    <p>{studentInfo?.passport_file && (
                        <a href={studentInfo?.passport_file} download target="_blank">
                            {lbl.Download}
                        </a>
                    )}</p>
                </div>
                <div className="detail_item">
                    <p>شهادت نامه</p>
                    <p>{studentInfo?.certificate_file && (
                        <a href={studentInfo?.certificate_file} download target="_blank">
                            {lbl.Download}
                        </a>
                    )}</p>
                </div>
            </div>
        </div>
    );
};

export default DocumentsInfo;
